<template>
  <v-alert outlined type="success" text>
    Your service project has been submitted successfully
  </v-alert>
</template>

<script>
export default {
  name: "ClubsList",

  props: ["clubContributions"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {
    
  },
};
</script>
